<template>
    <ModalFormCard class="modal-default" headerCSS='!h-0 !overflow-hidden'>
        <template #default="{ saving, errors }">
            <h1 class='text-27 font-bold'>There has been an error completing this action</h1>
            <p class='text-15 text-grey-900'>{{ editingModel.message }}</p>

            <button class='button-black h-10 px-6 mt-6' @click='$emit("close")'>Close</button>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    data() {

    },

    methods: {

    },

    computed: {
        errors() {
            return this.editingModel
        }, 
    },
}
</script>
